import facebookApi from '@/facebookApi';

export default {
  data() {
    return {
      loggedInFacebookUsername: null,
    };
  },
  methods: {
    facebookLogout() {
      if (FB) {
        FB.logout();
      }

      this.$bus.$emit('alert-success', {
        message: 'facebookLogoutSuccess',
        translate: true,
      });

      this.checkLoggedIntoFacebook();
    },
    checkLoggedIntoFacebook() {
      this.loggedInFacebookUsername = null;
      if (!FB) {
        return;
      }
      facebookApi.getFacebookUserName().then((username) => {
        this.loggedInFacebookUsername = username;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$nextTick(() => {
        vm.checkLoggedIntoFacebook();
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/mixins/facebookLogout.js